import React, { useRef, useEffect, useContext } from 'react';
import { TemplateContext } from '../layout';

function useOutsideAlerter(ref) {
	const [templateContext, setTemplateContext] = useContext(TemplateContext);

	useEffect(() => {
		function handleClickOutside(event) {
			const isWarrantyElement =
				event.target.classList.contains('warranty__check') ||
				event.target.classList.contains('warranty__label') ||
				event.target.classList.contains('button--warranty');

			if (ref.current && !ref.current.contains(event.target) && !isWarrantyElement) {
				setTemplateContext((prevContext) => ({
					...prevContext,
					popupClicked: true,
					displayPopup: false,
				}));
			}
		}
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [ref]);
}

const OutsideClick = ({ children }) => {
	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef);

	return (
		<div style={{ pointer: 'cursor' }} ref={wrapperRef}>
			{children}
		</div>
	);
};

export default OutsideClick;
